var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"font-weight-medium ag-status-chip py-3",attrs:{"small":"","color":_vm.color,"text-color":_vm.textColor}},[(_vm.icon)?_c('v-icon',{attrs:{"size":"16"}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]):_vm._e(),_vm._v(" "+_vm._s(_vm.label)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }